import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query'

type UseMaintenanceSolicitationsProps<T> = {
  filters?: {
    search?: string
    companyId?: string
    status?: string
    clientBranchId?: string
    equipmentId?: string
    kind?: string
    page?: number
  }
  options?: Partial<Omit<UseQueryOptions<any>, 'select' | 'queryKey' | 'queryFn'>>
  mapper?: (data: any) => T
}

export const useMaintenanceSolicitations = <T,>({
  filters: { search = '', companyId, status, clientBranchId, equipmentId, kind, page } = {},
  options = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceSolicitationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['maintenanceSolicitations', search, companyId, status, clientBranchId, equipmentId, kind, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/solicitations`, {
        params: {
          search,
          'q[company_id_eq]': companyId,
          'q[status_eq]': status,
          'q[branch_id_eq]': clientBranchId,
          'q[kind_eq]': kind,
          'q[equipment_id_eq]': equipmentId,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    ...options,
  })

  return { data, meta, isPending, ...rest }
}
